exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-pregunta[data-v-13305d6a]{display:flex;flex-direction:column;align-content:center;border:2px solid #54545c;border-radius:10px}.container-pregunta-text[data-v-13305d6a]{display:flex;justify-content:center;align-content:center;margin-top:15px;margin-bottom:20px}.container-pregunta-text div[data-v-13305d6a]{display:flex;align-items:center}.container-pregunta-answers[data-v-13305d6a]{display:flex;justify-content:space-evenly;align-content:center}.pregunta-button.icon[data-v-13305d6a]{font-size:3rem;margin-top:5px;margin-bottom:10px;cursor:pointer;color:#4a4a4a}.pregunta-button.icon.btn-green[data-v-13305d6a]{color:#48c774}.pregunta-button.icon.btn-red[data-v-13305d6a]{color:#d3142c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13305d6a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/visitas_Componentes/components/FormVisita.vue
// module id = 3883
// module chunks = 0